import { Action, handleActions } from 'redux-actions'
import { call, put, takeLeading } from 'redux-saga/effects'

import * as Bridge from '@/api/BridgeApi'
import { DEBIT_CARD_API_URL } from '@/api/DebitCardApi'
import {
  DEBIT_CARD_ROUTES,
  ENTRY_ROUTE_QUERY,
  STATUS_CODE,
  TOP_NATIVE_ROUTES,
} from '@/domains/CommonDomain'
import { errorActions } from '@/modules/common/error'
import { createPostAction } from '@/utils/actionUtils'
import {
  HostType,
  IRequestPinAuthResult,
  RequestPinAuthAction,
} from '@/utils/bridgeUtils/features/requestPinAuth'
import { newError } from '@/utils/errorUtils'
import { redirect } from '@/utils/historyUtils'
import { apiSuccessReducer } from '@/utils/reducerUtils'

export const DEBIT_CARD_DELETE = 'DebitCardDelete'

export const debitCardDeleteAsync = createPostAction(DEBIT_CARD_DELETE)

export interface IDebitCardDeleteState {
  defaultIssuanceFee: string
  issuanceFee: string
}

const initialState: IDebitCardDeleteState = {
  defaultIssuanceFee: '0',
  issuanceFee: '0',
}

export const reducer = {
  [debitCardDeleteAsync.SUCCESS]: apiSuccessReducer,
}

export function* deleteDebitCard(
  action: Action<{ debitCardNo: string; newDebitCardNo: string; acctNo: string }>,
) {
  try {
    const { debitCardNo, newDebitCardNo, acctNo } = action.payload

    const { result }: IRequestPinAuthResult = yield call(Bridge.enterTransactionPinForDebitCard, {
      hostType: HostType.BANK_API,
      apiUrl: DEBIT_CARD_API_URL.DELETE_DEBIT_CARD,
      request: { debitCardNo },
    })

    if (!result) {
      throw newError(STATUS_CODE.UNKNOWN_CLIENT_ERROR)
    }
    if (result.action === RequestPinAuthAction.CLOSE) {
      return
    }
    if (
      result.action === RequestPinAuthAction.AUTH_FAIL ||
      result.action === RequestPinAuthAction.AUTH_ERROR
    ) {
      // const { code } = JSON.parse(result.response)
      // throw newError(code)
      throw JSON.parse(result.response)
    }

    if (result.action === RequestPinAuthAction.AUTH_SUCCESS) {
      if (newDebitCardNo && acctNo) {
        yield call(
          redirect,
          `${DEBIT_CARD_ROUTES.DETAIL}/${newDebitCardNo}/${acctNo}?${ENTRY_ROUTE_QUERY}`,
        )
      } else {
        yield call(Bridge.navigateTo, TOP_NATIVE_ROUTES.ROOT)
      }
    }
  } catch (e) {
    yield put(errorActions.set(e))
  }
}

export const debitCardDeleteReducer = handleActions(reducer, initialState)
export const debitCardDeleteSaga = [takeLeading(debitCardDeleteAsync.POST, deleteDebitCard)]
